import React from "react";
import { Breakpoint, Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { AppModalTitle, IconButtonClose } from "./AppModal.styles";
import FloatingButtonsContainer from "../AppButtons/FloatingButtonsContainer";
import { AppIconsClose } from "../AppIcons";

type AppModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  title: string | React.ReactNode;
  maxWidth?: false | Breakpoint;
  buttonsElement?: React.ReactElement;
};
const AppModal: React.FC<React.PropsWithChildren<AppModalProps>> = (
  props: React.PropsWithChildren<AppModalProps>
) => {
  const open = props.open;
  const setOpen = props.setOpen;

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      maxWidth={props.maxWidth}
      fullWidth={true}
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <AppModalTitle sx={{ m: 0 }} id="customized-dialog-title">
        {props.title}
      </AppModalTitle>
      <IconButtonClose
        aria-label="close"
        onClick={handleClose}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.primary.contrastText,
        })}
      >
        <AppIconsClose />
      </IconButtonClose>
      <DialogContent>{props.children}</DialogContent>
      {/* <DialogActions>
        
        <BackButton onClick={handleClose}>Back</BackButton>
        <ConfirmButton autoFocus onClick={handleClose}>
          Save changes
        </ConfirmButton>
      </DialogActions> */}
      <FloatingButtonsContainer>
        {props.buttonsElement}
      </FloatingButtonsContainer>
    </Dialog>
  );
};
export default AppModal;
